import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';
import { MediaQuery } from '@spotahome/ui-library';

import HeroContainer from '../HeroContainer';
import HeaderContainer from '../HeaderContainer';

import './Hero.scss';

const { isMobileScreen, isPhabletScreen, isTabletScreen } = MediaQuery;

const HeroTenant = ({
  deviceType,
  renderCityAutocompleter = null,
  backgroundImage = null,
  title,
  subtitle = null,
  tracking
}) => {
  const [isDark, setIsDark] = useState(true);
  useEffect(() => {
    setIsDark(isMobileScreen() || isPhabletScreen() || isTabletScreen());
  }, []);

  const imageInlineStyle = !backgroundImage
    ? null
    : {
        backgroundImage
      };

  return (
    <section>
      <HeroContainer deviceType={deviceType}>
        <div className="hero-tenant__header-wrapper">
          <HeaderContainer
            color={{
              foregroundColor: isDark ? 'dark' : 'light',
              logoColor: isDark ? 'dark' : 'light'
            }}
            tracking={tracking}
          />
        </div>
        <div className={'hero-tenant__wrapper'} style={imageInlineStyle}>
          <div className="hero-tenant__container">
            <div className="hero-tenant__info">
              <div className="hero-tenant__info-content">
                <h1 className="hero-tenant__info-title">{trans(title)}</h1>
                {subtitle && (
                  <h2 className="hero-tenant__info-subtitle">
                    {trans(subtitle)}
                  </h2>
                )}
                {renderCityAutocompleter ? renderCityAutocompleter() : null}
              </div>
            </div>
          </div>
        </div>
      </HeroContainer>
    </section>
  );
};

HeroTenant.propTypes = {
  deviceType: PropTypes.oneOf(['smartphone', 'tablet', 'desktop']).isRequired,
  renderCityAutocompleter: PropTypes.func,
  backgroundImage: PropTypes.string,
  title: PropTypes.string.isRequired.isRequired,
  subtitle: PropTypes.string,
  tracking: PropTypes.string.isRequired
};

export default HeroTenant;
